import { CampaignDetailModel } from '@urbanx/agx.campaigns.client';
import ResumeFormDetails from '../Common/ResumeFormDetails';
import { Tabs } from 'types/Tabs';

interface AgencyAgreementSubmissionInfoPanelProps {
  campaign: CampaignDetailModel;
  currentTab: Tabs;
  mobile?: boolean;
}

const AgencyAgreementSubmissionInfoPanel = ({
  campaign,
  currentTab,
  mobile = false,
}: AgencyAgreementSubmissionInfoPanelProps) => (
  <ResumeFormDetails campaign={campaign} mobile={mobile} currentTab={currentTab} />
);

export default AgencyAgreementSubmissionInfoPanel;
